import React from "react";
import PropTypes from "prop-types";
import { Description, Heading } from "components/storages/Common";

export default function Intro({ intro }) {
	const { title, body, body2 } = intro;

	return (
		<>
			<Heading
				content={`Welcome to ${title}`}
				level="2"
			/>
			{intro.body && (
				<Description desc={body} />
			) }
			
			{intro.body2 && (
				<Description desc={body2} />
			)}
		</>
	);
}

Intro.propTypes = {
	intro: PropTypes.object
};
